<template>
    <div
        class="input-wrap relative flex"
        :class="{
            'w-full': type !== 'number',
            'w-1/5': type === 'number',
        }">
        <input
            :id="id"
            :value="fieldValue"
            :name="name"
            :type="type"
            class="border border-gray-450 focus:outline-none focus:shadow-gold disabled:bg-gray-300 disabled:text-gray-500"
            :class="{
                'px-4 py-3 w-full text-black-600': type !== 'checkbox' && type !== 'radio',
                'form-checkbox' : type === 'checkbox',
                'form-radio' : type === 'radio',
                'focus:bg-gold-500 checked:bg-gold-500' : (type === 'checkbox' || type === 'radio') && checked,
                'tracking-widest text-gold-600 focus:text-gold-500' : type === 'password',
                'mr-2 cursor-pointer transition duration-150 ease-in-out text-gold-500' : type === 'checkbox' || type === 'radio',
                'border-red-500 text-red-500 focus:border-red-500 focus:text-red-500' : hasErrors,
                'focus:border-gold-500 focus:text-black-600': ! hasErrors,
            }"
            :disabled="disabled"
            :placeholder="placeholder"
            :checked="checked"
            v-bind="$attrs"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
        />
        <slot />
    </div>
</template>

<script>
export default {
  name: 'TisInput',
  props: {
    id: {
      required: true,
    },
    value: {},
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    checked: {
      type: Boolean,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasErrors: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
